// ItemHelp.js
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TextField from "../../../common/TextField";
import AnswerList from "../../../common/AnswerList";

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid var(--Colors-Neutral-300, #e9ecef);
  margin-bottom: 24px;
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 12px;
`;

const TabButton = styled.button.attrs({ type: "button" })`
  padding: 6px 12px;
  margin-right: 8px;
  font-size: 0.9rem;
  background: ${({ active }) => (active ? "#f0f8ff" : "transparent")};
  border: none;
  border-bottom: ${({ active }) => (active ? "2px solid #007bff" : "none")};
  cursor: pointer;
  &:hover {
    background: #f8f9fa;
  }
`;

const SectionTitle = styled.h6`
  margin: 24px 0;
  font-weight: 600;
`;

const ItemHelp = ({
  sections = [], // full list
  initialSectionAnswers = {}, // { [sectionId]: [...] }
  initialSectionPrompts = {}, // { [sectionId]: "…" }
  onDataUpdate,
}) => {
  // 1. remove first & last
  const tabs = sections.slice(1, sections.length - 1);
  const firstId = tabs[0]?.id;

  const [activePromptId, setActivePromptId] = useState(firstId);
  const [activeAnswerId, setActiveAnswerId] = useState(firstId);

  const activePromptSection = tabs.find((s) => s.id === activePromptId);
  const activeAnswerSection = tabs.find((s) => s.id === activeAnswerId);

  const [prompts, setPrompts] = useState(
    Object.fromEntries(
      tabs.map((s) => [s.id, initialSectionPrompts[s.id] || ""])
    )
  );
  const [answers, setAnswers] = useState(
    Object.fromEntries(
      tabs.map((s) => [s.id, initialSectionAnswers[s.id] || [""]])
    )
  );

  // const [sectionPrompts, setSectionPrompts] = useState(() =>
  //   tabSections.reduce((acc, s) => {
  //     acc[s.id] = initialSectionPrompts[s.id] || "";
  //     return acc;
  //   }, {})
  // );

  // 4. bubble up on any change
  useEffect(() => {
    onDataUpdate({
      section_answers: answers,
      section_prompts: prompts,
    });
  }, [answers, prompts, onDataUpdate]);

  // const handlePromptChange = (e) => {
  //   setPrompt(e.target.value);
  // };

  // const handleAnswersChange = (answers) => {
  //   setSectionAnswers((prev) => ({
  //     ...prev,
  //     [activeSectionId]: answers,
  //   }));
  // };

  // const activeSection = tabSections.find((s) => s.id === activeSectionId);

  return (
    <>
      {/* PROMPTS */}
      <SectionContainer>
        <SectionTitle>Prompts</SectionTitle>
        <Tabs>
          {tabs.map((s, i) => (
            <TabButton
              key={s.id}
              active={s.id === activePromptId}
              onClick={() => setActivePromptId(s.id)}
            >
              Section {i + 1}
            </TabButton>
          ))}
        </Tabs>
        {activePromptSection && (
          <SectionTitle>{activePromptSection.title}</SectionTitle>
        )}
        <TextField
          isTextArea
          placeholder="Enter prompt"
          maxLength={250}
          value={prompts[activePromptId]}
          onChange={(e) =>
            setPrompts((p) => ({ ...p, [activePromptId]: e.target.value }))
          }
        />
      </SectionContainer>

      {/* STANDARD ANSWERS */}
      <SectionContainer>
        <SectionTitle>Standard Answers</SectionTitle>
        <Tabs>
          {tabs.map((s, i) => (
            <TabButton
              key={s.id}
              active={s.id === activeAnswerId}
              onClick={() => setActiveAnswerId(s.id)}
            >
              Section {i + 1}
            </TabButton>
          ))}
        </Tabs>
        {activeAnswerSection && (
          <SectionTitle>{activeAnswerSection.title}</SectionTitle>
        )}
        <AnswerList
          answers={answers[activeAnswerId]}
          onAnswersChange={(arr) =>
            setAnswers((a) => ({ ...a, [activeAnswerId]: arr }))
          }
        />
      </SectionContainer>
    </>
  );
};

export default ItemHelp;
